import ProjectRunConfiguration from "@app/projects/projectRunConfiguration";
import { formatDateTime, IconToggle, CheckItem } from "@app/shared";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";
import { toNumber, uniqWith, isEqual } from "lodash";
import { Component } from "react";

interface AccuracySelectComparisonRunConfigurationsFilterProps {
  alwaysShowFilters: boolean;
  canCompareResults: boolean;
  comparedProjectRunConfigId: number;
  exportType: string;
  filterDescription?: string;
  filterName?: string;
  handleCompareToggleChange: (active: boolean) => void;
  isComparingResults: boolean;
  onSourceRunConfigurationIdChange: (sourceRunConfigId: number) => void;
  onComparedRunConfigurationIdChange: (sourceRunConfigId: number) => void;
  onShowDifferenceOnlyChange?: (check: boolean) => void;
  runConfigurations: ProjectRunConfiguration[];
  showDifferenceOnlyCheckBox?: boolean;
  showDifferenceOnly?: boolean;
  sourceProjectRunConfigId: number;
}

export default class AccuracySelectComparisonRunConfigurationsFilter extends Component<AccuracySelectComparisonRunConfigurationsFilterProps> {

  constructor(props: AccuracySelectComparisonRunConfigurationsFilterProps) {
    super(props);
  }

  public render() {
    return (
      <>
        <p className="lead mb0 font-weight-bold">{this.props.filterName || "Timeframe Filter"}</p>
        <IconToggle active={this.props.isComparingResults} disabled={!this.props.canCompareResults} onToggle={this.props.handleCompareToggleChange} activeIconClass={["fa", "fa-toggle-on"]} inActiveIconClass={["fa", "fa-toggle-off"]} baseClassName={["qes-button qes-button-secondary"]}>Compare Results</IconToggle>
        {(this.props.alwaysShowFilters || (this.props.canCompareResults && this.props.isComparingResults)) && (
          <>
            <p>{this.props.filterDescription || "Please select a filter option:"}</p>
            <div className="form-group row">
              <div className="col-lg-12 ptb0">
                <QESSelect
                  label="Show providers from this run:"
                  testId={`export-${this.props.exportType}__format-select`}
                  className="form-control"
                  onChange={(e) => this.handleSourceRunConfigChange(toNumber(e.target.value))}
                  disabled={!this.props.isComparingResults && !this.props.alwaysShowFilters}
                  value={this.props.sourceProjectRunConfigId}
                >
                  <option key="-1" value="-1">{"-Select an option-"}</option>
                  {this.props.runConfigurations && uniqWith(this.props.runConfigurations, isEqual).map((rc) => (
                    <option key={rc.projectRunConfigurationId} value={rc.projectRunConfigurationId} disabled={rc.projectRunConfigurationId <= this.props.comparedProjectRunConfigId}>{this.getRunConfigDisplayName(rc)}</option>
                  ))}
                </QESSelect>
                <QESSelect
                  label="That have changed since this run:"
                  testId={`export-${this.props.exportType}__format-select`}
                  className="form-control"
                  onChange={(e) => this.handleComparedRunConfigChange(toNumber(e.target.value))}
                  disabled={!this.props.isComparingResults}
                >
                  <option key="-1" value="-1">{"-Select an option-"}</option>
                  {this.props.runConfigurations && uniqWith(this.props.runConfigurations, isEqual).map((rc) => (
                    <option key={rc.projectRunConfigurationId} value={rc.projectRunConfigurationId} disabled={rc.projectRunConfigurationId >= this.props.sourceProjectRunConfigId}>{this.getRunConfigDisplayName(rc)}</option>
                  ))}
                </QESSelect>
                {
                  this.props.showDifferenceOnlyCheckBox && 
                  (<CheckItem
                    name={"Show differences row only"}
                    checked={this.props.showDifferenceOnly}
                    indeterminate={false}
                    disabled={!this.props.isComparingResults}
                    onChecked={() => { this.handleDifferenceOnlyChange(true) }}
                    onUnchecked={() => { this.handleDifferenceOnlyChange(false) }}
                  />)
                }
              </div>
            </div>
          </>
        )}
      </>
    );
  }
  private getRunConfigDisplayName(rc: ProjectRunConfiguration) {    
    return `${formatDateTime(rc.dateCreated)}${!rc.datePublished ? " - UNPUBLISHED" : ""}`;
  }

  private handleSourceRunConfigChange(sourceRunConfigId: number) {
    this.props.onSourceRunConfigurationIdChange(sourceRunConfigId);
  }

  private handleComparedRunConfigChange(comparedRunConfigId: number) {
    this.props.onComparedRunConfigurationIdChange(comparedRunConfigId);
  }

  private handleDifferenceOnlyChange(check: boolean) {
    if (this.props.isComparingResults)
      this.props.onShowDifferenceOnlyChange(check);
  }
}
